import React from "react";
import "./Services.css";

import ServicesCart from "../Cart/ServicesCart";

import Icon1 from "../Icon/pen-tool.png";
import Icon2 from "../Icon/ux-design.png";
import Icon3 from "../Icon/app-development.png";
import Icon4 from "../Icon/smartphone.png";
import Icon5 from "../Icon/ux.png";
import Icon6 from "../Icon/database-storage.png";

export default function Services() {
  return (
    <div className="Services-Body">
      <div className="Services-Box">
        <p className="Services-Text1">|| My Services</p>
        <p className="Services-Text2">Service Provide For My Clients.</p>

        <div className="Services-Div">
          <ServicesCart
            img={Icon1}
            text1="Illustration"
            text2="Character"
            text3="Icon Set"
            text4="Illustration Guide"
            text5="Illustration Set"
            text6="Motion Graphic"
          />
          <ServicesCart
            img={Icon2}
            text1="UI/UX Design"
            text2="Landing Pages"
            text3="User Flow"
            text4="Prototyping"
            text5="Mobile App Design"
            text6="Figma & XD"
          />
          <ServicesCart
            img={Icon3}
            text1="Development"
            text2="HTML/CSS"
            text3="JavaScript"
            text4="TypeScript"
            text5="Animation"
            text6="React"
          />
        </div>

        <div className="Services-Div2">
          <ServicesCart
            img={Icon4}
            text1="Mobile Apps"
            text2="React Native"
            text3="Flutter"
            text4="Swift"
            text5="Kotlin"
            text6="Chakra UI"
          />
          <ServicesCart
            img={Icon5}
            text1="Web Apps"
            text2="React Js"
            text3="Next Js"
            text4="Node Js"
            text5="Bootstrap"
            text6="Tailwind CSS"
          />
          <ServicesCart
            img={Icon6}
            text1="Database"
            text2="Firebase"
            text3="MongoDB"
            text4="AWS"
            text5="MySQL"
            text6="Security"
          />
        </div>
      </div>
    </div>
  );
}
